<template>
  <div class="section mt-2 mb-2" id="submit_timesheets">
    <div class="row" v-if="selected_week == null">
      <div class="col-lg-12">
        <b-card header="TIMESHEET SUBMISSION" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
          <div class="row mr-0 ml-0 mt-2">
            <div class="col-12">
              <h3 class="font-weight-bold bp_color mb-4">Select Week Timesheets (Instructions) are to be submitted for</h3>
            </div>
            <div class="col-4">
              <h5 class="font-weight-bold week_beg">Week beginning :</h5>
            </div>
            <div class="col-4">
              <div class="form-group">
                <ValidationProvider rules="required" v-slot="{errors, classes}" name="Submission Week" tag="div">
                  <label class="form-label" for="submission_week">Submission Week</label>
                  <multiselect v-model="submission_week" id="submission_week" name="submission_week" placeholder="" :options="ms_opts.submission_week"
                               class="requiredField" :class="[classes, '']"></multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-4">
              <button class="btn orcaBtn w-100" @click.prevent="select_submission_week">Select Week</button>
            </div>

            <div class="col-4">
              <h5 class="font-weight-bold week_beg">Week ending (Friday) :</h5>
            </div>
            <div class="col-4">
              <span class="" style="line-height: 38px;">{{ submission_week_end }}</span>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <loadingCube v-if="!loading && selected_week !== null" :loaded="loading && selected_week !== null" :loadingMessage="'TIMESHEETS LOADING'"></loadingCube>
    <div v-show="loading === true && selected_week !== null" v-if="workers.length !== 0" class="row">
      <div class="col-12">
        <div class="card p-2 mb-3">
          <h5 class="bp_color text-center mb-0">This page performs an autosave every 5 minutes to ensure that you do not loose any work in progress.</h5>
          <p class="text-center mb-0">Please fill in and submit your timesheet instructions for this week.</p>
        </div>
      </div>
      <div class="col-12">
        <b-card header="TIMESHEET SUBMISSION" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
          <div class="row ml-0 mr-0 mt-2">

            <div class="col-md-6">
              <h3 class="font-weight-bold bp_color mb-2">Timesheets (Instructions) : To Complete</h3>
              <h5 class="font-weight-bold"><span style="display: inline-block; width: 240px;">For week beginning :</span> {{ submission_week }}</h5>
              <h5 class="font-weight-bold"><span style="display: inline-block; width: 240px;">For week ending :</span> {{ submission_week_end }}</h5>
              <h5 class="br-color font-weight-bold mt-3">This timesheet is not an invoice.</h5>
            </div>
            <div class="col-md-6">
              <h2 class="font-weight-bold bp_color">{{ client_name }}</h2>
              <h5 class="font-weight-bold"><span style="display: inline-block; width: 240px;">Workers left to submit :</span> {{ workers.length }}</h5>
              <h5 class="font-weight-bold"><span style="display: inline-block; width: 240px;">Running Total GROSS :</span> {{ total_gross | currency }}</h5>
              <h5 class="font-weight-bold"><span style="display: inline-block; width: 240px;">Retention Amount :</span> {{ total_retention | currency }}</h5>
            </div>

            <div class="col-12 mt-3">
              <div class="table-responsive">
                <table class="table table-striped table-sm c_t_sub" id="timesheet_submit_table">
                  <thead>
                  <tr>
                    <th scope="col" class="firstName">First Name</th>
                    <th scope="col" class="surname">Surname</th>
                    <th scope="col" class="payRate">Pay Rate</th>
                    <th scope="col" class="sites" :style="'z-index: ' + zindexcalc(index)" v-for="(value, key, index) in setup"
                        v-if="value !== null && key !== 'id' && key !== 'number_sites' && key !== 'company_id' && key !== 'created_at' && key !== 'updated_at' && key !== 'created_by' &&
                   key !==
                  'created_by_type' && key.includes('vat') === false">
                      <div><span>{{ value }}</span></div>
                    </th>
                    <th scope="col" class="totalHours">Total Hours</th>
                    <th scope="col" class="adjustments">Additions / Deductions<br>Description</th>
                    <th scope="col" class="totalAdditions">Total Additions</th>
                    <th scope="col" class="totalDeductions">Total Deductions</th>
                    <th scope="col" class="totalGross">Total<br>GROSS</th>
                    <th scope="col" class="releaseRetention">Retention<br>Amount</th>
                    <th scope="col" class="backNextWeek">Finished</th>
                    <th scope="col" class="backNextWeek">Back<br>Next<br>Week</th>
                    <th scope="col" class="releaseRetention">Release<br>Retention</th>
                    <!--              <th class="vvERROR" v-show="errors.items.length > 0"-->
                    <!--                  style="display: table-cell; min-width: 200px;">-->
                    <!--                <span v-show="errors.items.length > 0" class="help is-danger">Errors</span>-->
                    <!--              </th>-->
                    <th scope="col" class="submitPayroll">Submit<br>Payroll</th>
                  </tr>
                  </thead>
                  <!--            -->
                  <tbody id="to_complete_workers_tbody">
                  <tr v-for="n in workers.length" class="col-xl-12 pl-0 pr-0" :class="[workers[n-1].is_gang_leader === true ? 'gang_leader' : '']">

                    <td class="firstName">{{ workers[n - 1].first_name }}</td>
                    <td class="surname">{{ workers[n - 1].surname }}</td>
                    <td class="payRate">
                      <vue-numeric style="background: transparent;" currency="£" separator="," :precision="2" v-model="workers[n-1].pay_rate" @blur="calc(n-1)"
                                   :ref_input="n-1 + '_' + 0" :id_input="n-1 + '_' + 0"
                                   @keydown.native.37.prevent="inputMove('left', n-1,  0)"
                                   @keydown.native.38.prevent="inputMove('up', n-1,  0)"
                                   @keydown.native.39.prevent="inputMove('right', n-1, 0)"
                                   @keydown.native.40.prevent="inputMove('down', n-1,  0)"
                      ></vue-numeric>
                    </td>

                    <td class="sites" v-for="i in number_of_sites">
                      <input type="number" style="background: transparent;" min="0" v-model="workers[n-1]['site_' + i + '_units']" @change="calc(n-1)"
                             :ref="n-1 + '_' + calc_site_col(i, 1)" :id="n-1 + '_' + calc_site_col(i, 1)"
                             @keydown.37.prevent="inputMove('left', n-1,  calc_site_col(i, 1))"
                             @keydown.38.prevent="inputMove('up', n-1,  calc_site_col(i, 1))"
                             @keydown.39.prevent="inputMove('right', n-1,  calc_site_col(i, 1))"
                             @keydown.40.prevent="inputMove('down', n-1,  calc_site_col(i, 1))"
                      >
                    </td>
                    <td class="totalHours">{{ workers[n - 1].total_units }}</td>
                    <td class="adjustments">
                      <textarea style="background: transparent;" v-model="workers[n-1].adjustment_description"
                                :ref="ref_calc(n-1, 1)" :id="ref_calc(n-1, 1)"
                                @keydown.37.prevent="inputMove('left', n-1, col_calc(1))"
                                @keydown.38.prevent="inputMove('up', n-1, col_calc(1))"
                                @keydown.39.prevent="inputMove('right', n-1, col_calc(1))"
                                @keydown.40.prevent="inputMove('down', n-1, col_calc(1))"
                      ></textarea>
                    </td>
                    <td class="totalAdditions">
                      <vue-numeric style="background: transparent;" currency="£" separator="," :precision="2" v-model="workers[n-1].addition_amount" @blur="calc(n-1)"
                                   :ref_input="ref_calc(n-1, 2)" :id_input="ref_calc(n-1, 2)"
                                   @keydown.native.37.prevent="inputMove('left', n-1, col_calc(2))"
                                   @keydown.native.38.prevent="inputMove('up', n-1, col_calc(2))"
                                   @keydown.native.39.prevent="inputMove('right', n-1, col_calc(2))"
                                   @keydown.native.40.prevent="inputMove('down', n-1, col_calc(2))"
                      ></vue-numeric>
                    </td>
                    <td class="totalDeductions">
                      <vue-numeric style="background: transparent;" currency="£" separator="," :precision="2" v-model="workers[n-1].deduction_amount" @blur="calc(n-1)"
                                   :ref_input="ref_calc(n-1, 3)" :id_input="ref_calc(n-1, 3)"
                                   @keydown.native.37.prevent="inputMove('left', n-1, col_calc(3))"
                                   @keydown.native.38.prevent="inputMove('up', n-1, col_calc(3))"
                                   @keydown.native.39.prevent="inputMove('right', n-1, col_calc(3))"
                                   @keydown.native.40.prevent="inputMove('down', n-1, col_calc(3))"
                      ></vue-numeric>
                    </td>

                    <td class="totalGross">
                      {{ workers[n - 1].gross | currency }}
                      <input v-model="workers[n-1].gross" :name="'workers'+[n-1]+'gross'" hidden/>
                    </td>
                    <td class="releaseRetention" :style="[checkClientName ? {'padding': '0'} : {}]">
                      <vue-numeric v-if="client_name === 'FRENCH ROOFING SERVICES LIMITED' && !workers[n-1].release_retention" style="background: transparent;" currency="£"
                                   separator="," :precision="2"
                                   v-model="workers[n-1].retention_amount" @blur="calc(n-1)"
                                   :ref_input="ref_calc(n-1, 4)" :id_input="ref_calc(n-1, 4)"
                                   @keydown.native.37.prevent="inputMove('left', n-1, col_calc(4))"
                                   @keydown.native.38.prevent="inputMove('up', n-1, col_calc(4))"
                                   @keydown.native.39.prevent="inputMove('right', n-1, col_calc(4))"
                                   @keydown.native.40.prevent="inputMove('down', n-1, col_calc(4))"
                      ></vue-numeric>
                      <span v-else-if="client_name === 'FRENCH ROOFING SERVICES LIMITED' && workers[n-1].release_retention" style="font-size:0.9rem;">£ 0.00</span>
                      <span v-else style="font-size:0.9rem;">{{ workers[n - 1].retention_amount | currency }}</span>
                    </td>

                    <td class="backNextWeek">
                      <p-radio class="p-icon" v-model="workers[n-1].back_next_week" :name="'workers'+[n-1]+'back'" value="N">
                        <i slot="extra" class="icon fa fa-check"></i>
                      </p-radio>
                    </td>
                    <td class="backNextWeek">
                      <p-radio class="p-icon" v-model="workers[n-1].back_next_week" :name="'workers'+[n-1]+'back'" value="Y">
                        <i slot="extra" class="icon fa fa-check"></i></p-radio>
                    </td>
                    <td class="releaseRetention">
                      <p-check class="p-icon" v-model="workers[n-1].release_retention" @change="calc(n-1)">
                        <i slot="extra" class="icon fa fa-check"></i></p-check>
                      <span v-if="client_name !== 'FRENCH ROOFING SERVICES LIMITED'"
                            style="font-size:0.9rem; margin-left: 5px;">{{ workers[n - 1].retention_percentage }}&percnt;</span>
                    </td>
                    <!--                            <td class="vvERROR" v-show="errors.items.length > 0"-->
                    <!--                                style="display: table-cell; min-width: 200px;">-->
                    <!--                              <ul class="pl-3 mb-0">-->
                    <!--                                <li v-show="errors.has('workers' + [n-1] + 'back')" class="vvERROR">Select contractor 'Finished' / 'Back Next Week'.</li>-->
                    <!--                                <li v-show="errors.has('workers' + [n-1] + 'gross')" class="vvERROR">Negative gross payment.</li>-->
                    <!--                              </ul>-->

                    <!--                            </td>-->
                    <td class="submitPayroll">
                      <p-check class="p-icon" v-model="workers[n-1].submit_payroll">
                        <i slot="extra" class="icon fa fa-check"></i>
                      </p-check>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="set_all">
                <div class="set_all_card">
                  <h5 class="bp_color font-weight-bold">SET ALL WORKER SUBMISSION</h5>
                  <div class="pretty p-default p-curve">
                    <input type="radio" v-model="all_submit" value="Y">
                    <div class="state p-success-o">
                      <label>Workers Submit</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" v-model="all_submit" value="N">
                    <div class="state p-danger-o">
                      <label>Workers Clear Submit</label>
                    </div>
                  </div>
                </div>

                <div class="set_all_card">
                  <h5 class="bp_color font-weight-bold">SET ALL WORKER STATUS</h5>
                  <div class="pretty p-default p-curve">
                    <input type="radio" v-model="all_back_next_week" value="Y">
                    <div class="state p-success-o">
                      <label>Workers Back Next Week</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" v-model="all_back_next_week" value="N">
                    <div class="state p-danger-o">
                      <label>Workers Finished</label>
                    </div>
                  </div>
                  <div class="pretty p-default p-curve">
                    <input type="radio" v-model="all_back_next_week" value="Clear">
                    <div class="state p-warning-o">
                      <label>Clear Workers Finished/Back Next Week</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-striped table-sm running_site_totals c_t_sub">
                  <thead>
                  <tr>
                    <th scope="col" class="firstName"></th>
                    <th scope="col" class="sites" :style="'z-index: ' + zindexcalc(index)" v-for="(value, key, index) in setup"
                        v-if="value !== null && key !== 'id' && key !== 'number_sites' && key !== 'company_id' && key !== 'created_at' && key !== 'updated_at' && key !==
                                'created_by' && key !== 'created_by_type' && key.includes('vat') === false">
                      <div><span>{{ value }}</span></div>
                    </th>
                    <th scope="col" class="totalGross">Total Units</th>
                    <th scope="col" class="text-center">Total Additions</th>
                    <th scope="col" class="text-center">Total Deductions</th>
                    <th scope="col" class="totalGross">Running GROSS</th>
                    <th scope="col" class="totalGross">Retention Amount</th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr class="col-xl-12 pl-0 pr-0">
                    <td class="firstName font-weight-bold">Site Totals</td>
                    <td class="sites" v-for="st in site_totals">{{ st | currency }}</td>
                    <td>-</td>
                    <td>{{ total_additions | currency }}</td>
                    <td>{{ total_deductions | currency }}</td>
                    <td class="totalGross">{{ total_gross | currency }}</td>
                    <td class="totalGross">{{ total_retention | currency }}</td>
                  </tr>

                  <tr class="col-xl-12 pl-0 pr-0">
                    <td class="firstName font-weight-bold">Site Total Units</td>
                    <td class="sites" v-for="stu in site_total_units">{{ stu }}</td>
                    <td>{{ total_units }}</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="row">
                <div class="col-lg-6 col-xl-7">
                  <div style="text-align: right;">

                            <span id="certifyText">I certify that I am an authorised member of {{ client_name }} and that the above named persons have attended site and
                              should be paid for the total payments above.<br>
                              {{ client_name }} agrees to be bound by the Terms of Business of Genius Money as previously received and signed.<br>
                              Any retention payments indicated will be released to the sub-contractor upon instruction by {{ client_name }}.
                            </span>
                    <p-check class="p-icon" style="vertical-align: top; font-size: 23px; margin-top: 5px;" v-model="agree_submit">
                      <i slot="extra" class="icon fa fa-check"></i>
                    </p-check>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-5">
                  <!--                          <div class="vvERROR" v-show="errors.items.length > 0">-->
                  <!--                            <span class="font-weight-bold mb-2 d-block">Please check Errors column for issues with submission.</span>-->
                  <!--                          </div>-->
                  <button class="btn orcaBtn w-100" @click="submit_timesheet()" :disabled="agree_submit === false || saving === true">
                    <span v-if="saving === false">SAVE PROGRESS & SUBMIT COMPLETED INSTRUCTIONS</span>
                    <span v-else-if="saving === true"><i class="fas fa-spinner fa-spin"></i> SUBMITTING ...</span>
                  </button>
                </div>

                <div class="offset-md-4 col-md-8 offset-lg-6 col-lg-6 offset-xl-7 col-xl-5">
                  <button class="btn orcaBtn grey_bg w-100 mt-3 mb-3" @click="temp_save_timesheet()" :disabled="saving_for_later === true">
                    <span v-if="saving_for_later === false">SAVE TO FINISH LATER</span>
                    <span v-else-if="saving_for_later === true"><i class="fas fa-spinner fa-spin"></i> SAVING ...</span>

                  </button>
                </div>
              </div>

            </div>
          </div>
        </b-card>
      </div>
      <div class="col-12 mt-4">
        <b-card header="SUBMITTED TIMESHEETS" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
          <div v-show="loading === true && selected_week !== null" class="row ml-0 mr-0 mt-2">
            <div class="col-md-6">
              <h3 class="font-weight-bold bp_color mb-0">Submitted Timesheets (Instructions)</h3>
              <h5 class="font-weight-bold"><span style="display: inline-block; width: 240px;">For week beginning :</span> {{ submission_week }}</h5>
              <h5 class="font-weight-bold"><span style="display: inline-block; width: 240px;">For week ending :</span> {{ submission_week_end }}</h5>
            </div>
            <div class="col-md-6">
              <h5 class="font-weight-bold"><span style="display: inline-block; width: 410px;">Workers submitted :</span> {{ completed_timesheets.length }}</h5>
              <h5 class="font-weight-bold"><span style="display: inline-block; width: 410px;">Total GROSS for timesheets submitted :</span> {{ submitted_total_gross | currency }}
              </h5>
              <h5 class="font-weight-bold"><span style="display: inline-block; width: 410px;">Total Retention for timesheets submitted :</span>
                {{ submitted_total_retention | currency }}</h5>
            </div>

            <div v-if="completed_timesheets.length === 0" class="col-12 mt-3">
              <div><p class="font-weight-bold">No Completed Timesheets for this week</p></div>
            </div>
            <div v-else class="col-12 mt-3">
              <div class="table-responsive">
                <table class="table  table-striped table-sm c_t_sub" id="submitted_workers">
                  <thead>
                  <tr>
                    <th scope="col" class="firstName">First Name</th>
                    <th scope="col" class="surname">Surname</th>
                    <th scope="col" class="payRate">Submission Week</th>
                    <th scope="col" class="payRate">Pay Rate</th>
                    <th scope="col" class="sites" :style="'z-index: ' + zindexcalc(index)"
                        v-for="(value, key, index) in setup"
                        v-if="value !== null && key !== 'id' && key !== 'number_sites' && key !== 'company_id' && key !== 'created_at' && key !== 'updated_at' && key !==
                            'created_by' && key !==
                            'created_by_type' && key.includes('vat') === false">
                      <div><span>{{ value }}</span></div>
                    </th>
                    <th scope="col" class="totalHours">Total Hours</th>
                    <th scope="col" class="adjustments">Additions / Deductions<br>Description</th>
                    <th scope="col" class="totalAdditions">Total Additions</th>
                    <th scope="col" class="totalDeductions">Total Deductions</th>
                    <th scope="col" class="totalGross">Total<br>GROSS</th>
                    <th scope="col" class="totalGross">Retention<br>Amount</th>
                    <th scope="col" class="backNextWeek">Back<br>Next<br>Week</th>
                    <th scope="col" class="releaseRetention">Release<br>Retention</th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr v-for="n in completed_timesheets.length" class="col-xl-12 pl-0 pr-0">
                    <td class="firstName">{{ completed_timesheets[n - 1].first_name }}</td>
                    <td class="surname">{{ completed_timesheets[n - 1].surname }}</td>
                    <td class="payRate">{{ completed_timesheets[n - 1].submission_week }}</td>

                    <td class="payRate">{{ completed_timesheets[n - 1].pay_rate | currency }}</td>

                    <td class="sites" v-for="i in number_of_sites">{{
                        completed_timesheets[n - 1]['site_' + i +
                        '_units']
                      }}
                    </td>

                    <td class="totalHours">{{ completed_timesheets[n - 1].total_units }}</td>
                    <td class="adjustments">{{ completed_timesheets[n - 1].adjustment_description }}</td>
                    <td class="totalAdditions">{{ completed_timesheets[n - 1].addition_amount | currency }}</td>
                    <td class="totalDeductions">{{ completed_timesheets[n - 1].deduction_amount | currency }}</td>
                    <td class="totalGross">{{ completed_timesheets[n - 1].gross | currency }}</td>
                    <td class="totalGross">{{ completed_timesheets[n - 1].retention_amount | currency }}</td>
                    <td class="backNextWeek">
                      <span v-if="completed_timesheets[n-1].back_next_week === 'Y'">Yes</span>
                      <span v-if="completed_timesheets[n-1].back_next_week === 'N'">No</span>
                    </td>
                    <td class="releaseRetention">
                      <span v-if="completed_timesheets[n-1].release_retention === '1' || completed_timesheets[n-1].release_retention === true">Yes</span>
                      <span v-else-if="completed_timesheets[n-1].release_retention === '0' || completed_timesheets[n-1].release_retention === false">No</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="table-responsive mt-4">
                <table class="table table-striped table-sm submitted_site_totals c_t_sub">
                  <thead>
                  <tr>
                    <th scope="col" class="firstName"></th>
                    <th scope="col" class="sites" :style="'z-index: ' + zindexcalc(index)" v-for="(value, key, index) in setup"
                        v-if="value !== null && key !== 'id' && key !== 'number_sites' && key !== 'company_id' && key !== 'created_at' && key !== 'updated_at' && key !==
                            'created_by' && key !== 'created_by_type' && key.includes('vat') === false">
                      <div><span>{{ value }}</span></div>
                    </th>
                    <th>Total Units</th>
                    <th>Total Additions</th>
                    <th>Total Deductions</th>
                    <th scope="col" class="totalGross">Submitted GROSS</th>
                    <th scope="col" class="totalGross">Submitted Retention</th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr class="col-xl-12 pl-0 pr-0">
                    <td class="firstName font-weight-bold">Site Totals</td>
                    <td class="sites" v-for="st in submitted_site_totals">{{ st | currency }}</td>
                    <td class="text-center">-</td>
                    <td class="text-center">{{ submitted_total_additions | currency }}</td>
                    <td class="text-center">{{ submitted_total_deductions | currency }}</td>
                    <td class="totalGross">{{ submitted_total_gross | currency }}</td>
                    <td class="totalGross">{{ submitted_total_retention | currency }}</td>
                  </tr>
                  <tr class="col-xl-12 pl-0 pr-0">
                    <td class="firstName font-weight-bold">Site Total Units</td>
                    <td class="sites" v-for="stu in submitted_site_total_units">{{ stu }}</td>
                    <td class="text-center">{{ submitted_total_units }}</td>
                    <td class="text-center">-</td>
                    <td class="text-center">-</td>
                    <td class="text-center">-</td>
                    <td class="text-center">-</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </b-card>
      </div>

    </div>

    <!--    {{ load_test() }}-->
  </div>
</template>
<script>
import Vue from 'vue'
import Multiselect from 'vue-multiselect';
import PrettyCheckbox from 'pretty-checkbox-vue';
import VueNumeric from './vueNumeric'
import loadingCube from "loaders/record_loader";

import moment from 'moment-mini';

Vue.use(PrettyCheckbox);

export default {
  name: "client_timesheets_submission",
  components: {loadingCube, Multiselect, VueNumeric},
  data() {
    return {
      l1: false,
      l2: false,
      l3: false,
      loading: false,
      submission_week: null,
      selected_week: null,
      submission_week_end: "",
      ms_opts: {
        submission_week: []
      },

      all_back_next_week: null,
      all_submit: null,

      client_name: "",

      setup: {},
      number_of_sites: "",

      total_gross: 0,
      total_additions: 0,
      total_deductions: 0,
      total_retention: 0,
      submitted_total_gross: 0,

      site_totals: {},
      site_total_units: {},
      total_units: 0,
      submitted_site_totals: {},
      submitted_site_total_units: {},
      submitted_total_units: 0,
      submitted_total_additions: 0,
      submitted_total_retention: 0,
      submitted_total_deductions: 0,

      load_workers: [],
      workers: [],
      completed_timesheets: [],

      historic_timesheets: [],
      historic_setups: [],

      agree_submit: false,
      logged_in_user: {},

      saving: false,
      saving_for_later: false,

      interval: null,
    }
  },
  created() {
    let three_weeks_ago = moment.utc().isoWeekday(-20).format('DD-MM-YYYY').toString();
    let two_weeks_ago = moment.utc().isoWeekday(-13).format('DD-MM-YYYY').toString();
    let last_week = moment.utc().isoWeekday(-6).format('DD-MM-YYYY').toString();
    let this_week = moment.utc().isoWeekday('Monday').format('DD-MM-YYYY').toString();
    let next_week = moment.utc().isoWeekday(+8).format('DD-MM-YYYY').toString();

    this.submission_week = last_week;
    this.submission_week_end = moment.utc(last_week, 'DD-MM-YYYY').isoWeekday(+5).format('MMMM Do YYYY').toString();
    this.ms_opts.submission_week = [three_weeks_ago, two_weeks_ago, last_week, this_week, next_week];
  },
  mounted() {
    this.autosave(true);
    this.logged_in_user = this.$store.state.auth.me;
    // axios.get('/client/get/website_user').then(response => this.logged_in_user = response.data);
  },
  methods: {
    checkClientName() {
      return this.client_name === 'FRENCH ROOFING SERVICES LIMITED';
    },
    select_submission_week() {
      this.selected_week = this.submission_week;

      this.$nextTick(() => {
        new Promise(resolve => {
          axios.get(this.crmApiPath + 'contact/' + this.$store.state.auth.me.contact_id + '/company/show').then(company => {
            this.client_name = company.data.company_name;
            this.l1 = true;

            axios.get(this.crmApiPath + 'timesheet_setup/contact/' + company.data.id).then(setup => {
              this.setup = setup.data;

              axios.post(this.crmApiPath + 'client/timesheets/get/workers/to_complete', {
                company_id: company.data.id,
                number_sites: this.setup.number_sites,
                submission_week: this.selected_week
              }).then(response => {
                this.number_of_sites = setup.data.number_sites;
                this.workers = response.data;

                this.total_gross = 0;
                this.total_additions = 0;
                this.total_deductions = 0;
                this.total_retention = 0;
                for (let i in this.workers) {
                  this.total_gross += parseFloat(this.workers[i].gross);
                  this.total_additions += parseFloat(this.workers[i].addition_amount);
                  this.total_deductions += parseFloat(this.workers[i].deduction_amount);
                  this.total_retention += parseFloat(this.workers[i].retention_amount);
                }
                // this.total_gross = this.total_gross + this.total_additions - this.total_deductions;

                for (let i = 0; i < this.number_of_sites; i++) {
                  this.site_totals['site_' + [i + 1]] = 0;
                  this.site_total_units['site_' + [i + 1]] = 0;
                }
                for (let i = 0; i < this.number_of_sites; i++) {
                  this.submitted_site_totals['site_' + [i + 1]] = 0;
                  this.submitted_site_total_units['site_' + [i + 1]] = 0;
                }

                this.l2 = true;

                this.$nextTick(() => {
                  axios.post(this.crmApiPath + 'client/timesheets/get/workers/submitted', {
                    company_id: company.data.id,
                    submission_week: this.selected_week,
                    'sort_workers_by': 'Surname',
                  }).then(response => {
                    this.completed_timesheets = response.data;

                    this.calc_site_total_gross();
                    this.calc_submitted_gross();
                    this.calc_submitted_retention();
                    this.calc_submitted_site_gross_totals();
                    this.calc_submitted_total_additions();
                    this.calc_submitted_total_deductions();
                    this.calc_submitted_total_retention();

                    this.l3 = true;
                    resolve();
                  });

                });
              });

            });

          })
        }).then(() => this.load_test())

      })

    },
    load_test() {
      this.$nextTick(() => {
        if (this.l1 === true && this.l2 === true && this.l3 === true) {
          this.loading = true;
        }
      });
    },
    inputMove(key, row, col) {
      let max_num_rows = this.workers.length - 1;
      let max_num_cols = parseInt(this.number_of_sites) + 4;

      switch (key) {
        case 'left':
          let ref1 = row + "_" + (col - 1);
          if (col !== 0) {
            document.getElementById(ref1).focus();
          }
          break;
        case 'up':
          let ref2 = row - 1 + "_" + (col);
          if (row !== 0) {
            document.getElementById(ref2).focus();
          }
          break;
        case 'right':
          let ref3 = row + "_" + (col + 1);
          if (col !== max_num_cols) {
            document.getElementById(ref3).focus();
          }
          break;
        case 'down':
          let ref4 = row + 1 + "_" + (col);
          if (row !== max_num_rows) {
            document.getElementById(ref4).focus();
          }
          break;
      }
    },
    zindexcalc(index) {
      return 80 - index;
    },

    calc_site_col(i, num) {
      return parseInt(i) - 1 + num
    },
    col_calc(add_to_site_total) {
      return parseInt(this.number_of_sites) + add_to_site_total
    },
    ref_calc(row, add_to_site_total) {
      let col = parseInt(this.number_of_sites) + add_to_site_total;
      return row + "_" + col;
    },

    autosave() {
      this.$nextTick(function () {

        this.interval = window.setInterval(() => {
          if (this.workers.length > 0) {
            let formData = new FormData();
            formData.append('submission_week', this.submission_week);

            for (let i = 0; i < this.workers.length; i++) {
              formData.append('worker_' + i, JSON.stringify(this.workers[i]));
            }

            axios.post(this.crmApiPath + 'client/timesheets/temp/save', formData, {
              headers: {
                'Content-Type': 'application/json'
              }
            })
                // .then(res => console.log(res.data));
            this.$snotify.success('5 min Timesheets Auto Save');
          }
        }, 300000);
        // }, 3000);
      })
    },

    setup_for_timesheet(week_end_date) {
      let temp_historic_setup = this.historic_setups;
      temp_historic_setup = Object.keys(temp_historic_setup).filter(function (key) {
        if (key >= week_end_date) {
          return temp_historic_setup[key]
        }
      });
      return this.historic_setups[temp_historic_setup[0]][0];
    },
    setup_num_sites(week_end_date) {
      let temp_historic_num_sites = this.historic_setups;
      temp_historic_num_sites = Object.keys(temp_historic_num_sites).filter(function (key) {
        if (key >= week_end_date) {
          return temp_historic_num_sites[key]
        }
      });
      return this.historic_setups[temp_historic_num_sites[0]][0]['number_sites'];
    },

    calc(worker_row) {
      this.calc_total_units(worker_row);
      this.calc_gross(worker_row);
      this.calc_retention(worker_row);
      this.calc_site_total_gross();
      this.total_gross = 0;
      this.total_additions = 0;
      this.total_deductions = 0;
      this.total_retention = 0;
      for (let i in this.workers) {
        this.total_gross += parseFloat(this.workers[i].gross);
        this.total_additions += parseFloat(this.workers[i].addition_amount);
        this.total_deductions += parseFloat(this.workers[i].deduction_amount)
        this.total_retention += parseFloat(this.workers[i].retention_amount)
      }
      // this.total_gross = this.total_gross + this.total_additions - this.total_deductions;
    },
    calc_site_total_gross() {
      for (let i = 0; i < this.number_of_sites; i++) {
        this.site_totals['site_' + [i + 1]] = 0;
        this.site_total_units['site_' + [i + 1]] = 0;
      }

      this.total_units = 0;

      for (let w in this.workers) {
        for (let i = 0; i < this.number_of_sites; i++) {
          if (this.workers[w]['site_' + [i + 1] + '_units'] !== null && this.workers[w]['site_' + [i + 1] + '_units'] !== '') {
            let site_total = (parseFloat(this.workers[w]['site_' + [i + 1] + '_units']) * parseFloat(this.workers[w].pay_rate))
            this.site_totals['site_' + [i + 1]] += site_total;

            this.site_total_units['site_' + [i + 1]] += parseFloat(this.workers[w]['site_' + [i + 1] + '_units']);

            this.total_units += parseFloat(this.workers[w]['site_' + [i + 1] + '_units']);
          }
        }
      }
    },
    calc_total_units(worker_row) {
      let total_units = 0;
      for (let t in this.workers[worker_row]) {
        if (t.includes('site_') === true) {
          if (this.workers[worker_row].hasOwnProperty(t)) {
            if (this.workers[worker_row][t] !== null && this.workers[worker_row][t] !== "") {
              total_units += parseFloat(this.workers[worker_row][t])
            }
          }
        }
      }

      this.workers[worker_row].total_units = total_units;
    },
    calc_gross(worker_row) {
      let pay_rate = 0;
      let total_units = 0;
      let total_additions = 0;
      let total_deductions = 0;

      if (this.workers[worker_row].pay_rate !== null && this.workers[worker_row].pay_rate !== "") {
        pay_rate = parseFloat(this.workers[worker_row].pay_rate);
      }
      if (this.workers[worker_row].total_units !== null && this.workers[worker_row].total_units !== "") {
        total_units = parseFloat(this.workers[worker_row].total_units)
      }
      if (this.workers[worker_row].addition_amount !== null && this.workers[worker_row].addition_amount !== "") {
        total_additions = parseFloat(this.workers[worker_row].addition_amount);
      }
      if (this.workers[worker_row].deduction_amount !== null && this.workers[worker_row].deduction_amount !== "") {
        total_deductions = parseFloat(this.workers[worker_row].deduction_amount);
      }

      this.workers[worker_row].gross = (pay_rate * total_units) + total_additions - total_deductions;
    },
    calc_retention(worker_row) {
      // RETENTION
      if (this.client_name !== 'FRENCH ROOFING SERVICES LIMITED') {
        if (this.workers[worker_row].release_retention === 0 || this.workers[worker_row].release_retention === false) {
          this.workers[worker_row].retention_amount = this.workers[worker_row].gross * (parseFloat(this.workers[worker_row].retention_percentage) / 100);
        }
        else {
          this.workers[worker_row].retention_amount = 0;
        }
      }
    },

    calc_submitted_gross() {
      this.submitted_total_gross = 0;
      for (let i in this.completed_timesheets) {
        this.submitted_total_gross += parseFloat(this.completed_timesheets[i].gross)
      }
    },
    calc_submitted_retention() {
      this.submitted_total_retention = 0;
      for (let i in this.completed_timesheets) {
        this.submitted_total_retention += parseFloat(this.completed_timesheets[i].retention_amount)
      }
    },
    calc_submitted_site_gross_totals() {
      for (let w in this.completed_timesheets) {
        for (let i = 0; i < this.number_of_sites; i++) {
          if (this.completed_timesheets[w]['site_' + [i + 1] + '_units'] !== null && this.completed_timesheets[w]['site_' + [i + 1] + '_units'] !== '') {
            this.submitted_site_totals['site_' + [i + 1]] += (parseFloat(this.completed_timesheets[w]['site_' + [i + 1] + '_units']) * parseFloat(this.completed_timesheets[w].pay_rate));

            this.submitted_site_total_units ['site_' + [i + 1]] += parseFloat(this.completed_timesheets[w]['site_' + [i + 1] + '_units']);

            this.submitted_total_units += parseFloat(this.completed_timesheets[w]['site_' + [i + 1] + '_units']);
          }
        }
      }
    },
    calc_submitted_total_additions() {
      this.submitted_total_additions = 0;
      for (let i in this.completed_timesheets) {
        this.submitted_total_additions += parseFloat(this.completed_timesheets[i].addition_amount)
      }
    },
    calc_submitted_total_deductions() {
      this.submitted_total_deductions = 0;
      for (let i in this.completed_timesheets) {
        this.submitted_total_deductions += parseFloat(this.completed_timesheets[i].deduction_amount)
      }
    },
    calc_submitted_total_retention() {
      this.submitted_total_retention = 0;
      for (let i in this.completed_timesheets) {
        this.submitted_total_retention += parseFloat(this.completed_timesheets[i].retention_amount)
      }
    },

    temp_save_timesheet() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Save To Finish Later</div>' +
            '<div class="snotifyToast__body">' +
            'Save your currently inputted data for this weeks timesheet instructions.' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$snotify.remove(toast.id);
              this.saving_for_later = true;
              let formData = new FormData();
              formData.append('submission_week', this.submission_week);

              for (let w in this.workers) {
                for (let i = 0; i < this.number_of_sites; i++) {
                  if (this.workers[w]['site_' + [i + 1] + '_units'] === "") {
                    this.workers[w]['site_' + [i + 1] + '_units'] = null;
                  }
                }
              }

              for (let i = 0; i < this.workers.length; i++) {
                formData.append('worker_' + i, JSON.stringify(this.workers[i]));
              }

              axios.post(this.crmApiPath + 'client/timesheets/temp/save', formData, {
                headers: {
                  'Content-Type': 'application/json'
                }
              }).then(() => {
                this.$router.go()
                this.$snotify.success('Timesheet Saved');
                // this.$alertify.success("Timesheets Saved<br>(" + moment().format('LT') + ")")
              })
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });

    },

    submit_timesheet() {
      // this.$validator.validateAll().then((result) => {
      //   if (result) {

      // this.$alertify.confirmWithTitle(
      //     "<i class='fas fa-save'></i><span>Submit Timesheets</span>",
      //     "<p class='mb-3'>Submit all timesheets with the 'Submit Payroll' checkbox selected</p>" +
      //     "<p>Any timesheets with data inputted but not selected for submission will have their data saved for later completion.</p>",
      //     () => {
      this.saving = true;
      for (let w in this.workers) {
        for (let i = 0; i < this.number_of_sites; i++) {
          if (this.workers[w]['site_' + [i + 1] + '_units'] === "") {
            this.workers[w]['site_' + [i + 1] + '_units'] = null;
          }
        }
      }

      let formData = new FormData();
      formData.append('submission_week', this.submission_week);
      let tempFormData = new FormData();
      tempFormData.append('submission_week', this.submission_week);

      let emailFormData = new FormData();

      let check = 0, m = 0;
      let sub_total = 0, sub_add = 0, sub_ded = 0, sub_ret = 0;

      for (let i = 0; i < this.workers.length; i++) {
        if (this.workers[i].submit_payroll === true) {
          formData.append('worker_' + m, JSON.stringify(this.workers[i]));
          emailFormData.append('worker_' + m, JSON.stringify(this.workers[i]));

          sub_total += this.workers[i].gross;
          sub_add += this.workers[i].addition_amount;
          sub_ded += this.workers[i].deduction_amount;
          sub_ret += parseFloat(this.workers[i].retention_amount);

          check++;
          m++;
        }
      }
      emailFormData.append('client_email', this.logged_in_user.email);
      emailFormData.append('contact_name', this.logged_in_user.first_name + ' ' + this.logged_in_user.surname);
      emailFormData.append('client_name', this.client_name);
      emailFormData.append('sub_total', sub_total.toFixed(2));
      emailFormData.append('sub_add', sub_add.toFixed(2));
      emailFormData.append('sub_ded', sub_ded.toFixed(2));
      emailFormData.append('sub_ret', sub_ret.toFixed(2));

      let k = 0;
      for (let j = 0; j < this.workers.length; j++) {
        if (this.workers[j].submit_payroll !== true) {
          tempFormData.append('worker_' + k, JSON.stringify(this.workers[j]));
          k++;
        }
      }
      // formData.append('client_email', this.logged_in_user.email);
      // for (var pair of formData.entries()) {
      //   console.log(pair[0]+ ', ' + pair[1]);
      // }

      axios.post(this.crmApiPath + 'client/timesheets/save', formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(() => {
        if (check > 0) {
          axios.post(this.crmApiPath + 'client/timesheets/email', emailFormData, {headers: {'Content-Type': 'application/json'}});
        }

        axios.post(this.crmApiPath + 'client/timesheets/temp/save', tempFormData, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(() => {
          this.$snotify.success('Timesheet Submitted');
          this.$router.go()
          // document.location.href = '/client/timesheets/submission';
          // this.$alertify.success("Timesheets Submitted<br>(" + moment().format('LT') + ")");
        })
      });
      //     },
      //     () => {
      //     }
      // )
      // }
      // });
    },

    set_all_back_next_week_true(item, index) {
      this.workers[index].back_next_week = 'Y';
    },
    set_all_back_next_week_false(item, index) {
      this.workers[index].back_next_week = 'N';
    },
    set_all_back_next_week_clear(item, index) {
      this.workers[index].back_next_week = null;
    },
    set_all_submit(item, index) {
      this.workers[index].submit_payroll = true;
    },
    clear_all_submit(item, index) {
      this.workers[index].submit_payroll = false;
    }

  },
  watch: {
    submission_week(val) {
      this.submission_week_end = moment.utc(val, 'DD-MM-YYYY').isoWeekday(+5).format('MMMM Do YYYY').toString();
    },
    all_back_next_week(val) {
      if (val === 'Y') {
        this.workers.forEach(this.set_all_back_next_week_true)
      }
      else if (val === 'N') {
        this.workers.forEach(this.set_all_back_next_week_false)
      }
      else if (val === 'Clear') {
        this.workers.forEach(this.set_all_back_next_week_clear)
      }
    },
    all_submit(val) {
      if (val === 'Y') {
        this.workers.forEach(this.set_all_submit)
      }
      else if (val === 'N') {
        this.workers.forEach(this.clear_all_submit)
      }
    },
  },
  beforeDestroy() {
    window.clearTimeout(this.interval);
  }
}
</script>
<style lang="scss">
.week_beg {
  vertical-align: top;
  width:          370px;
  display:        inline-block;
  line-height:    38px;
}

.submission_week {
  vertical-align: top;
  display:        inline-block;
  width:          calc(100% - 400px);
  z-index:        999;
}

#certifyText {
  font-size:   0.75em;
  line-height: 15px;
  display:     inline-block;
  width:       calc(100% - 45px);
  float:       left;
}

input[type="number"]::-webkit-outer-spin-button, input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin:             0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

#submit_timesheets {
  .pretty.p-icon .state .icon {
    position:    absolute;
    /* font-size: 1.15em; */
    width:       calc(1em + 2px);
    height:      calc(1em + 2px);
    left:        0;
    z-index:     1;
    text-align:  center;
    line-height: normal;
    top:         2px;
    border:      1px solid transparent;
  }

  .pretty .state label:before, .pretty .state label:after {
    top:    2px;
    height: 23px;
    width:  23px;
  }

  .pretty {
    margin-right: 0;
    color:        white;

    input {
      width: 100% !important;
    }
  }

  .pretty input:checked ~ .state .icon, .pretty input:checked ~ .state .svg, .pretty.p-toggle .state .icon, .pretty.p-toggle .state .svg {
    color:            white;
    background-color: $bc_1;
  }

  .table-responsive {
    height:     auto;
    max-height: 475px;
    overflow-y: auto;
  }
}

.set_all {
  .set_all_card {
    padding:       10px;
    margin:        10px;
    border:        1px solid $bc_1;
    border-radius: 5px;
    display:       inline-block;
    float:         right;
  }

  .pretty {
    .state {
      color:        $bc_3;
      margin-right: 20px;
    }
  }
}

.table.c_t_sub {

  &.table-striped tbody tr:nth-of-type(odd) {
    td {
      background-color: rgba(lighten($bc_4, 45%), 1);
    }
  }

  &.table-striped tbody tr:nth-of-type(even) {
    td {
      background-color: rgba(lighten($bc_4, 35%), 1);
    }
  }

  tr {
    &.gang_leader {
      td {
        background-color: lighten(#FFD734, 25%) !important;
      }

    }
  }

  thead {
    background-color: rgba(lighten($bc_4, 35%), 1) !important;

    th {
      position:           sticky;
      top:                0;
      background:         $white !important;
      z-index:            5;
      border:             none;
      -webkit-box-shadow: 0 1px 0 0 rgba($bc_3, 0.75);
      -moz-box-shadow:    0 1px 0 0 rgba($bc_3, 0.75);
      box-shadow:         0 1px 0 0 rgba($bc_3, 0.75);

      &.sites {
        height:         140px;
        white-space:    nowrap;
        vertical-align: inherit;
      }

      &.sites > div {
        transform: translate(10px, 50px) rotate(315deg);
        width:     30px;
      }

      &.sites > div > span {
        padding: 0 5px;
      }
    }
  }

  td {
    vertical-align: middle;
    position:       relative;
    height:         45px;
    line-height:    15px;

    input, textarea {
      border:  1px solid darken($bc_4, 5%);
      display: block;
      height:  100%;
      width:   100%;
    }
  }

  .firstName, .surname {
    min-width:        150px;
    position:         sticky;
    left:             0;
    z-index:          85;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  .surname {
    left: 150px;
  }

  .payRate, .totalAdditions, .totalDeductions {
    max-width:        110px;
    min-width:        110px;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  .sites {
    max-width:        60px;
    min-width:        60px;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  .totalHours {
    text-align:       center;
    min-width:        100px;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  .adjustments {
    min-width:        250px;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  .totalGross {
    min-width:        120px;
    text-align:       center;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  .backNextWeek {
    max-width:        75px;
    min-width:        75px;
    position:         sticky;
    left:             0;
    z-index:          30;
    //background: transparent;
    text-align:       center;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  .releaseRetention {
    max-width:        80px;
    min-width:        80px;
    position:         sticky;
    left:             0;
    z-index:          30;
    //background: transparent;
    text-align:       center;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  .submitPayroll {
    max-width:        75px;
    min-width:        75px;
    text-align:       center;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  td {
    &.submitPayroll {
      font-size: 1.25rem;
    }

    &.firstName, &.surname {
      z-index: 28;
    }

    &.payRate, &.sites, &.adjustments, &.totalAdditions, &.totalDeductions {
      padding: 0;
    }

    &.backNextWeek {
      font-size: 1.25rem;
      z-index:   27;
    }

    &.releaseRetention {
      font-size: 1.25rem;
      z-index:   27;
    }
  }

  &.submitted_workers {
    span {
      font-size: 0.9rem;
    }

    td {
      &.firstName, &.surname {
        z-index: 28;
      }

      &.payRate, &.sites, &.adjustments, &.totalAdditions, &.totalDeductions {
        padding: 0.3rem;
      }

      &.sites {
        text-align: center;
      }

      &.backNextWeek {
        font-size: 1.25rem;
        z-index:   28;
      }

      &.releaseRetention {
        font-size: 1.25rem;
        z-index:   28;
      }
    }
  }
}

.running_site_totals, .submitted_site_totals {

  td {
    &.sites {
      /*width: 150px;*/
      max-width: 150px;
      min-width: 90px;
    }
  }

}
</style>
